import { makeStyles } from '@material-ui/core/styles';

export const useEnterAcccountNumberStyle = makeStyles(theme => ({
    registrationContainer: {
        maxWidth: '754px',
        marginTop: '17px',
        marginBottom: '17px',
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: '0px 30px',

        '@media(max-width: 599px)': {
            padding: '0px 24px',
            width: '100%',
            marginTop: '48px',
            marginBottom: '0px',
        },
    },
    cardContainer: {
        width: '100%',
        height: '100%',
        paddingLeft: '32px',
        paddingRight: '30px',
        paddingTop: '24px',
        paddingBottom: '24px',

        background: theme.palette.primary.white,
        boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
        borderRadius: '10px',

        '@media(max-width: 599px)': {
            background: theme.palette.primary.white,
            boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
            borderRadius: '10px 10px 0px 0px',

            paddingLeft: '16px',
            paddingRight: '16px',
            paddingTop: '17.5px',
            paddingBottom: '17.5px',
        },
    },
    bodyContainer: {
        minHeight: '155px',
        paddingTop: '42px',
        paddingBottom: '8px',
        position: 'relative',

        '@media(max-width: 599px)': {
            minHeight: '294px',
            paddingTop: '24px',
            paddingBottom: '24px',
            paddingLeft: '16px',
            paddingRight: '16px',
        },

        '& .register-account-body': {
            maxWidth: '376px',
            margin: '0px auto',

            '& input[type=number]::-webkit-inner-spin-button,& input[type=number]::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: '0',
            },
            '& input[type=number]': {
                MozAppearance: 'textfield',
            },
        },

        '& .register-grid-text-information, & .register-grid-input-field': {
            marginBottom: '32px',
            '@media(max-width: 599px)': {
                marginBottom: '23px',
            },
        },

        '& .register-grid-text-content': {
            // fontFamily: "gt-walsheim-regular",
            // fontStyle: "normal",
            // fontWeight: 400,
            // fontSize: "14px",
            // lineHeight: "22px",
            // color: "rgba(50, 52, 53, 0.87)",
            color: theme.palette.primary.heather,

            textAlign: 'left',
        },

        ' & .register-grid-input-field': {
            ' & .register-grid-input-text-field': {
                width: '100%',

                fontFamily: theme.typography.body2.fontFamily,
                fontStyle: 'normal',
                fontWeight: 400,

                ' & .text-field-input-label-props-root': {
                    color: theme.palette.primary.heather80,
                    fontFamily: theme.typography.body2.fontFamily,
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: theme.typography.body1.fontSize,
                    lineHeight: '19px',
                    letterSpacing: '0.15px',
                },
                '& .text-field-input-label-props-focused, & .text-field-input-label-props-shrink': {
                    color: theme.palette.primary.heather,
                    // fontSize: "12px",
                    lineHeight: '16px',
                },
                '& .text-field-input-label-props-focused-invalid, & .text-field-input-label-props-shrink-invalid': {
                    color: theme.palette.primary.error,
                },
                ' & .text-field-input-props-root': {
                    '& .text-field-input-props-input': {
                        color: theme.palette.primary.heather,
                        fontFamily: theme.typography.body2.fontFamily,
                        fontStyle: 'normal',
                        fontWeight: 400,
                        fontSize: theme.typography.body1.fontSize,
                        lineHeight: '19px',
                        letterSpacing: '0.15px',

                        padding: '19px 12px 18px 12px',
                    },
                },
                ' & .text-field-input-props-root-filled': {
                    ' & .text-field-input-props-notchedOutline': {
                        borderColor: theme.palette.primary.heather,
                        borderWidth: '2px',
                    },
                    ' & .text-field-input-props-notchedOutline-invalid': {
                        borderColor: theme.palette.primary.error,
                    },
                },
                ' & .text-field-input-props-focused, & .text-field-input-props-root:hover': {
                    ' & .text-field-input-props-notchedOutline': {
                        borderColor: theme.palette.primary.heather,
                    },
                    ' & .text-field-input-props-notchedOutline-invalid': {
                        borderColor: theme.palette.primary.error,
                    },
                },
            },

            '& .invalid-account-number-entered': {
                fontFamily: theme.typography.body2.fontFamily,
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: theme.typography.inputLabel.fontSize,
                lineHeight: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                letterSpacing: '0.4px',
                color: theme.palette.primary.error,

                marginTop: '3px',
            },
        },
    },
    inputColor: {
        color: theme.palette.primary.heather,
    },
}));
